import * as React from 'react';
import type {ComponentProps, PropsWithChildren} from 'react';

import {Button} from '@spaced-out/ui-design-system/lib/components/Button';

import css from './brand-button.css';


type IBrandButtonProps = PropsWithChildren & ComponentProps<typeof Button>;
export const BrandButton = ({...otherProps}: IBrandButtonProps) => {
  return <Button {...otherProps} classNames={{wrapper: css.brandButton}} />;
};
